import { getTermsConditions } from '@/actions/legalPlages'
import { focusIds } from '@/constants/focus'
import { settingsTitles } from '@/constants/settings'

import { StaticHTMLPage } from './StaticHTMLPage'

const focusId = `${focusIds.SETTINGS_TERMS_CONDITIONS}${focusIds.CONTAINER_MOD}`

export const TermsConditions = () => (
  <StaticHTMLPage
    titleTranslationKey={settingsTitles.TERMS_CONDITIONS}
    onPageLoad={getTermsConditions}
    focusId={focusId}
  />
)
